// extracted by mini-css-extract-plugin
module.exports = {"partnersListTitle":"pgLwf","partnersList":"oCd8F","partnersListInner":"Wb9F3","loadingWrapper":"y9ePM"};